module.exports = __webpack_public_path__ + "img/img_18@2x.572c736f.png";